














import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class GridContainer extends Vue {
  @Prop(Boolean) readonly fluid!: boolean;

  get classes() {
    const { root, fluid } = this.$style;

    return {
      [root]: true,
      [fluid]: this.fluid,
    };
  }
}
